import React from "react";
import profile from "../../Assets/Images/undraw_profile.svg";
import moment from "moment";

const Call = ({ sess, reason = "" }) => {
  return (
    <div className="container-fluid top-container">
      <div className="row">
        <div className="col-md-12 post mb-5">
          <div className="card h-100">
            <div className="card-body">
              <div className="row">
                <div className="col-md-1"></div>
                <div className="col-md-4">
                  <p className="pro-title">Mentor</p>
                  <br />
                  <div className="profile-card mt-3">
                    <div className="card-body p-3">
                      <div className="d-flex">
                        <img
                          className="img-profile rounded-circle"
                          src={sess?.mentor_pic_url || profile}
                          alt="mentor-profile"
                        />
                        <p className="mt-2 ml-2 mb-0">{sess?.mentor_name}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <p className="pro-title">Mentee </p>
                  <br />
                  <div className="profile-card mt-3">
                    <div className="card-body p-3">
                      <div className="d-flex">
                        <img
                          className="img-profile rounded-circle"
                          src={sess?.mentee_pic_url || profile}
                          alt="mentee-profile"
                        />
                        <p className="mt-2 ml-2 mb-0">{sess?.mentee_name}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-md-1"></div>
                <div className="col-md-9">
                  <table className="table">
                    <tr>
                      <td className="border-top-0 view-tab">Title</td>
                      <td className="border-top-0 view-tab">:</td>
                      <td className="border-top-0 view-tab">
                        {sess?.service_name ? sess.service_name : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-top-0 view-tab">Date</td>
                      <td className="border-top-0 view-tab">:</td>
                      <td className="border-top-0 view-tab">
                        {sess?.end_time &&
                          moment(sess?.end_time).format("DD.MM.YYYY")}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-top-0 view-tab">
                        Call&nbsp;duration
                      </td>
                      <td className="border-top-0 view-tab">:</td>

                      <td className="border-top-0 view-tab">
                        {sess?.duration && `${sess?.duration} Min`}&nbsp;
                        {sess?.start_time &&
                          sess?.end_time &&
                          `(${moment
                            .utc(sess?.start_time)
                            .format("h:mm A")} - ${moment
                            .utc(sess?.end_time)
                            .format("h:mm A")})`}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-top-0 view-tab">Price</td>
                      <td className="border-top-0 view-tab">:</td>
                      <td className="border-top-0 view-tab">
                        {sess?.net_price}
                      </td>
                    </tr>
                    {reason !== "" && (
                      <tr>
                        <td className="border-top-0 view-tab">{reason}</td>
                        <td className="border-top-0 view-tab">:</td>
                        <td className="border-top-0 view-tab">
                          {sess?.comments}
                        </td>
                      </tr>
                    )}
                    {reason === "Cancellation reason" && (
                      <tr>
                        <td className="border-top-0 view-tab">Refund Amount</td>
                        <td className="border-top-0 view-tab">:</td>
                        <td className="border-top-0 view-tab">
                          {sess?.refund}
                        </td>
                      </tr>
                    )}
                    {reason === "Cancellation reason" && (
                      <tr>
                        <td className="border-top-0 view-tab">Cancelled By</td>
                        <td className="border-top-0 view-tab">:</td>
                        <td className="border-top-0 view-tab">
                          {sess?.cancel_by_name}
                        </td>
                      </tr>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Call;
